/**
 * @deprecated use Separator
 */
const VerticalSeparator = () => {
  return (
    <div className="mx-[10px] flex h-full items-center">
      <div className="h-[20px] w-[2px] bg-gray-dark" />
    </div>
  );
};

export default VerticalSeparator;
